<template>
  <div v-wechat-title="titleTop" class="allBack">
    <div v-if="type === 'home'" class="rect">
      <div class="topImageRect">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(image, index) in images" :key="index">
            <img v-lazy="image">
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="fullButtonRect">
        <van-button
          type="primary"
          class="buttonStart"
          size="normal"
          :disabled="!initFinish"
          @click="onStart"
        >生成我的专属海报</van-button>
      </div>
      <div v-if="showFollow" class="FollowRectBack">
        <div class="FollowRect">
          <div class="title">你还没有关注MySSI公众号哦!</div>
          <div class="qrRect"><img src="/img/third/ssiocean/qrcode1.jpg"></div>
          <van-button v-if="!isIOS" type="primary" class="button" size="small" @click="onFollowWx">扫一扫 关注公众号</van-button>
          <div v-if="isIOS" class="title">长按 关注公众号!<br>在公众号对话框输入“海洋”</div>
        </div>
      </div>
    </div>
    <div v-if="type === 'upload'" class="rect">
      <div class="IconRect">
        <div class="tools" @click="rotateImg"><i class="iconfont iconrotate" /></div>
        <vueCropper
          ref="cropper"
          class="cutIconRect"
          :img="option.img"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="false"
          :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
          :center-box="option.centerBox"
          :fixed-box="option.fixedBox"
          :max-img-size="option.maxImgSize"
          :enlarge="option.enlarge"
        />
        <div class="nickNameRect">
          <van-field v-model="userInfo.nickName" label="昵称" placeholder="请输入昵称" />
        </div>
        <van-uploader :after-read="onRead" style="width: 50% !important;">
          <van-button square plain type="primary" size="large">选择照片</van-button>
        </van-uploader>

        <van-button
          square
          type="primary"
          size="large"
          style="width:50%;"
          :loading="uploadIconLoading"
          loading-text="生成中..."
          @click="uploadIcon"
        >生成海报</van-button>
      </div>
    </div>
    <div v-if="type === 'finish'" class="rect">
      <img :src="imgUrl" style="width:100%">
    </div>
    <wxShare
      v-model="showShare"
      share-title="点击这里分享"
      :title="shareTitle"
      :desc="shareAbout"
      :timeline="shareTimeline"
      :url="shareUrl"
      :img="shareIcon"
      @onFinish="onShareFinish"
    />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Swipe, SwipeItem, Uploader, Field } from 'vant'
import { VueCropper } from 'vue-cropper'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'

export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    VueCropper,
    wxShare
  },
  data() {
    return {
      isIOS: false,
      titleTop: '世界海洋日 X SSI',
      images: ['/img/third/ssiocean/2023ad1.png',
        '/img/third/ssiocean/2023ad2.png',
        '/img/third/ssiocean/2023ad3.png'],
      type: 'home',
      initFinish: false,
      showFollow: false,
      uploadIconLoading: false,
      userInfo: {
        thirdUserId: undefined,
        isFollow: false,
        nickName: ''
      },
      imgUrl: undefined,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [10, 10], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        maxImgSize: 2000,
        enlarge: 1,
        autoCropWidth: 1040,
        autoCropHeight: 800
      },
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: undefined,
      shareIcon: ''

    }
  },

  created() {
    var u = navigator.userAgent
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    this.init()
  },
  methods: {
    GetSelfUrl,
    MyNotify,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      var thirdUserId = getUrlKey('thirdUserId')
      var code = getUrlKey('code')
      const isDebug = false // 是否是调试模式
      if (!thirdUserId && !code) {
        if (isDebug) {
          this.initFinish = true
          this.userInfo = {
            isFollow: true
          }
        } else {
          // 登录
          this.getWxLoginUrl((url) => {
            console.log('跳转页面去登录', url)
            window.location.href = url
          })
        }

        return
      }

      this.$router.push('/ssioceanday')
      var my = this
      var loginPro = setInterval(() => {
        my.loginProgress += 1
        if (my.loginProgress > 99) {
          my.loginProgress = 99
          clearInterval(loginPro)
        }
      }, 10)
      if (thirdUserId) {
        this.loginAndRegThirdUserInfo(null, thirdUserId, () => {
          // this.loginThirdFinish(my)
          this.initShare()
        })
      } else {
        // 读取注册用户信息
        this.loginAndRegThirdUserInfo(code, null, () => {
          // this.loginThirdFinish(my)
          this.initShare()
        })
      }
    },
    initShare() {
      this.shareTitle = '世界海洋日 X SSI'
      this.shareAbout = '像大海治愈我们时一样 治愈她'
      this.shareTimeline = '世界海洋日 X SSI'
      this.shareIcon = GetSelfUrl() + 'img/third/ssiocean/ssiIcon.jpg'
      this.shareUrl = undefined
      this.shareUrl = 'https://store.myssi.cn/ssioceanday'
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onFollowWx() {
      var wxBiz = 'MzU2NTkyMjAwMg=='
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=' + wxBiz + '&scene=110#wechat_redirect'
    },
    getWxLoginUrl(callback) {
      request({
        url: '/ThirdActivitie/wechatLogin',
        method: 'post',
        data: {
          url: 'https://m.myssi.cn/jump/ssioceanday',
          type: 'BASE'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        var url = Response.data
        if (callback) {
          callback(url)
        }
      })
    },
    loginAndRegThirdUserInfo(code, thirdUserId, callback) {
      request({
        url: '/ThirdActivitie/GetAndRegThirdActiviteUser',
        method: 'post',
        data: {
          code: code,
          thirdUserId: thirdUserId,
          type: 'BASE',
          keyCode: 'SSI202106'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.initFinish = true
        this.userInfo = Response.data
        if (callback) {
          callback()
        }
      })
    },
    onStart() {
      if (this.userInfo.isFollow) {
        this.type = 'upload'
      } else {
        MyNotify('info', '你还没有关注MySSI公众号哦!')
        this.showFollow = true
      }
    },
    rotateImg() {
      if (this.option.img === undefined || this.option.img == null || this.option.img === '') {
        return
      }
      this.$refs.cropper.rotateRight()
    },
    onRead(file) {
      this.option.img = file.content
    },
    uploadIcon() {
      this.uploadIconLoading = true
      //       var url = GetServiceUrlBase() + '/userAPI/ThirdActivitie/GetiLab202104CardImage?name=' + this.name
      // this.imgUrl = url
      // var height = this.$refs.cropper.cropH
      // console.log(height)
      // var bl = height / 130.0
      // console.log(bl)
      this.option.enlarge = 1
      this.$refs.cropper.getCropData((data) => {
        request({
          url: '/ThirdActivitie/GetSSIWordOceanDayImage',
          method: 'post',
          data: {
            icon: data,
            name: this.userInfo.nickName
          }
        }).then(response => {
          this.uploadIconLoading = false
          if (!response.success) {
            return
          }
          this.imgUrl = 'data:' + response.data.ContentType + ';base64,' + response.data.FileContents
          this.type = 'finish'
        })
      })
    }
  }
}
</script>
<style>
.van-uploader__input-wrapper {
  width: 100% !important;
}

.uploadbutton button {
  width: 100%;
}
</style>

<style scoped>
.topImageRect {
  padding: 1em;
}

.topImageRect img {
  width: 100%;
}

.allBack {
  min-height: 100vh;
  background-color: #fff;
}

.fullButtonRect {
  padding: 0 1em;
}

.fullButtonRect .buttonStart {
  width: 100%;
}

.FollowRectBack {
  background-color: rgba(0, 0, 0, 0.3);
}

.FollowRect {
  z-index: 10;
  position: absolute;
  width: 60vw;
  margin-left: 20vw;
  margin-top: 10vw;
  border: 1px solid #000;
  padding: 5vw 0;
  background-color: #fff;
  top: 20vh;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
}

.FollowRect .title {
  font-size: 4vw;
  text-align: center;
}

.FollowRect .qrRect {
  width: 24vw;
  padding-left: 18vw;
  padding-top: 3vw;
  text-align: center;
}

.FollowRect .qrRect img {
  width: 100%;

}

.FollowRect .button {
  text-align: center;
  border: 1px solid #000;
  width: 40vw;
  margin-left: 10vw;
  margin-top: 5vw;
  font-weight: 700;
  font-size: 3.8vw;
}

.cutIconRect {
  width: 100%;
  height: calc(100vh - 6.2em) !important;
}

.tools {
  position: absolute;
  right: 1.5em;
  top: 1.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  text-align: center;
  background-color: #fff;
}

.IconRect {
  background-color: #fff;
}

.nickNameRect {
  background-color: #d1d1d1;
  border-top: 1px solid #f1f1f1;
}
</style>
